import {CBAR_I18N_SOURCE_ADDED_EVENT} from '@cbar/cbar-i18n';

/**
 * PaymentNGN-specific strings not yet in the CBAR baseline dictionary.
 * Merged additively with `@cbar/cbar-localizations` via the same event channel.
 */
const paymentNgnResources = {
  en: {
    translation: {
      Date: 'Date',
      Amount: 'Amount',
      Receipt: 'Receipt',
      'View receipt': 'View receipt',
      'Download receipt': 'Download receipt',
      'Total payments': 'Total payments',
      'All time': 'All time',
      'Financial Year-to-date': 'Financial Year-to-date',
      Outstanding: 'Outstanding',
      'Upcoming recurring payment': 'Upcoming recurring payment',
      invoice: 'invoice',
      invoices: 'invoices',
      'recurring payments': 'recurring payments',
      'Recent payments': 'Recent payments',
      Payments: 'Payments',
      Organisation: 'Organisation',
      'Your profiles': 'Your profiles',
      'Active recurring payments': 'Active recurring payments',
      'View all payments': 'View all payments',
      'View full history': 'View full history',
      'View all recurring payments': 'View all recurring payments',
      'Manage all': 'Manage all',
      'Manage recurring payments': 'Manage recurring payments',
      Frequency: 'Frequency',
      Payment: 'Payment',
      'You have not made any payments yet.': 'You have not made any payments yet.',
      Campaign: 'Campaign',
      'Next payment': 'Next payment',
      'Select profile': 'Select profile',
      'Please select your profile from the list below.': 'Please select your profile from the list below.',
      'You do not currently have a profile.': 'You do not currently have a profile.',
      'Previous payments': 'Previous payments',
      Invoices: 'Invoices',
      'Recurring payments': 'Recurring payments',
      'Payment methods': 'Payment methods',
      'Saved payment methods': 'Saved payment methods',
      'Cards and bank accounts saved for faster checkout.':
        'Cards and bank accounts saved for faster checkout.',
      'Payment methods are saved separately for each person or organisation. A recurring payment can only use methods belonging to the same payer.':
        'Payment methods are saved separately for each person or organisation. A recurring payment can only use methods belonging to the same payer.',
      'Paying as': 'Paying as',
      'No cards or bank accounts saved for {name} yet.':
        'No cards or bank accounts saved for {name} yet.',
      'No cards or bank accounts saved yet.': 'No cards or bank accounts saved yet.',
      'Invoice number': 'Invoice number',
      Status: 'Status',
      Invoice: 'Invoice',
      Download: 'Download',
      Cancelled: 'Cancelled',
      "Doesn't expire": "Doesn't expire",
      'You have no recurring payments set up.': 'You have no recurring payments set up.',
      'You have no payment methods saved.': 'You have no payment methods saved.',
      'No payment methods saved for this profile yet.':
        'No payment methods saved for this profile yet.',
      'Add payment method': 'Add payment method',
      Add: 'Add',
      'Only methods for {name} can be used for this payment.':
        'Only methods for {name} can be used for this payment.',
      'Only methods belonging to the same payer as this recurring payment can be used.':
        'Only methods belonging to the same payer as this recurring payment can be used.',
      'Update payment method': 'Update payment method',
      'Cancel recurring payment': 'Cancel recurring payment',
      'Cancel payment': 'Cancel payment',
      'Payment method': 'Payment method',
      'Please select a payment method.': 'Please select a payment method.',
      'Unable to load payment methods.': 'Unable to load payment methods.',
      'Unable to update recurring payment.': 'Unable to update recurring payment.',
      'Unable to prepare cancellation.': 'Unable to prepare cancellation.',
      'Updated Recurring Payment Successfully': 'Updated Recurring Payment Successfully',
      'This will cancel this recurring payment. Future scheduled payments will stop.':
        'This will cancel this recurring payment. Future scheduled payments will stop.',
      'A payment for this period is already processing with the payment gateway or bank.':
        'A payment for this period is already processing with the payment gateway or bank.',
      'Cancelling will not reverse a payment that has already been sent, and it may still complete.':
        'Cancelling will not reverse a payment that has already been sent, and it may still complete.',
      'There is an upcoming payment task for this schedule. It will be cancelled, but any open invoice may remain.':
        'There is an upcoming payment task for this schedule. It will be cancelled, but any open invoice may remain.',
      'There is no payment task in progress right now.':
        'There is no payment task in progress right now.',
      Success: 'Success',
      'Feel free to close this dialog using the confirm button below': 'Feel free to close this dialog using the confirm button below',
      Confirm: 'Confirm',
      'Are you sure?': 'Are you sure?',
      Cancel: 'Cancel',
      Recurring: 'Recurring',
      card: 'card',
      'debit account': 'debit account',
      'recurring payment': 'recurring payment',
      'This will remove your selected': 'This will remove your selected',
      'Please confirm below.': 'Please confirm below.',
      Dashboard: 'Dashboard',
      'My Account': 'My Account',
      Admin: 'Admin',
      Logout: 'Logout',
    },
  },
};

if (typeof globalThis !== 'undefined' && globalThis.window) {
  globalThis.window.dispatchEvent(
    new CustomEvent(CBAR_I18N_SOURCE_ADDED_EVENT, {
      detail: {
        resources: paymentNgnResources,
        defaults: {
          fallbackLng: 'en-AU',
          currency: 'AUD',
        },
      },
    }),
  );
}
